import React, { useEffect, useState } from 'react';
import { Autocomplete } from '../../ps-aspect-design';

export default function AutoCompleteWrapper(props) {
  const [value, setValue] = useState(props.value);
  const [suggestions, setSuggestions] = useState(props.allSuggestions);
  const [isLoading, setIsLoading] = useState(false);
  const [timeoutRef, setTimeoutRef] = useState();

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const onInputChange = (newInput = '') => {
    setValue(newInput);
    setIsLoading(true);
    if (timeoutRef) {
      clearTimeout(timeoutRef);
    }
    setTimeoutRef(
      setTimeout(() => {
        const newSuggestions = props.allSuggestions?.filter(item =>
          item.toLowerCase().includes(newInput?.toLowerCase())
        );
        setSuggestions(newSuggestions);
        setIsLoading(false);
      }, 250)
    );
  };

  const onSelectionSelect = suggestion => {
    setValue(suggestion);
    props.onChange(suggestion);
  };

  const onClear = () => {
    setValue('');
    props.onChange('');
    setSuggestions(props.allSuggestions);
  };

  return (
    <>
      <Autocomplete
        className="field-filter__element-dropdown"
        isLoading={isLoading}
        onClear={onClear}
        onInputChange={onInputChange}
        onSelectionChange={onSelectionSelect}
        placeholder={props.placeholder}
        suggestions={suggestions}
        value={value}
      />
    </>
  );
}
